import { api } from 'app/app.api';

import {
  CreateIntentDetectionApiArg,
  CreateIntentDetectionApiResponse,
  DeleteIntentDetectionApiArg,
  ReadIntentDetectionApiArg,
  ReadIntentDetectionApiResponse,
  ReadIntentDetectionsApiResponse,
  UpdateIntentDetectionApiArg,
  UpdateIntentDetectionApiResponse,
} from './types/intentDetectionApi.types';

export const intentDetectionApi = api
  .enhanceEndpoints({
    addTagTypes: ['IntentDetection'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readIntentDetection: builder.query<
        ReadIntentDetectionApiResponse,
        ReadIntentDetectionApiArg
      >({
        query: (arg) => ({
          version: 1,
          path: `intent-detection/${arg.id}`,
        }),
        providesTags: ['IntentDetection'],
      }),
      readIntentDetections: builder.query<
        ReadIntentDetectionsApiResponse,
        void
      >({
        query: () => ({
          version: 1,
          path: `intent-detection`,
        }),
        providesTags: ['IntentDetection'],
      }),
      createIntentDetection: builder.mutation<
        CreateIntentDetectionApiResponse,
        CreateIntentDetectionApiArg
      >({
        query: (arg) => ({
          version: 1,
          path: 'intent-detection',
          method: 'POST',
          body: arg,
        }),
        invalidatesTags: ['IntentDetection'],
      }),
      updateIntentDetection: builder.mutation<
        UpdateIntentDetectionApiResponse,
        UpdateIntentDetectionApiArg
      >({
        query: ({ id, name, description }) => ({
          version: 1,
          path: `intent-detection/${id}`,
          method: 'PUT',
          body: { name, description },
        }),
        invalidatesTags: ['IntentDetection'],
      }),
      deleteIntentDetection: builder.mutation<
        void,
        DeleteIntentDetectionApiArg
      >({
        query: ({ id }) => ({
          version: 1,
          path: `intent-detection/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['IntentDetection'],
      }),
    }),
  });
